import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogTitle, DialogContent, Icon } from '@mui/material'
import { PaperArrastavel } from 'app/components/dialog-arrastavel/PaperArrastavel'
import { SelecionarColunasParaExibicao } from 'app/components/selecionar-colunas-para-exibicao/SelecionarColunasParaExibicao'
import { IColuna } from 'app/types/IColuna'
import { traduzirNomeColuna } from 'app/utils/UtilsColunas'
import clsx from 'clsx'
import * as R from 'ramda'
import React, { memo, useMemo, useState } from 'react'
import { compararColunas as compararColunasGridItens } from '../obterColunas'
import { compararColunas as compararColunasGridConsultaItens } from '../obterColunasConsultaItens'
const estilosGridItens = require('../grid-itens.module.scss').default
const estilosTableHead = require('./tableHead.module.scss').default
import { Coluna as ColunaSelecao } from '../../../selecionar-colunas-para-exibicao/SelecionarColunasParaExibicao'
const tipografia = require('../../../estilos-reutilizaveis/tipografia.module.scss').default;

export type AcoesHeadProps = {
    id: string
    onAlterarFonte?: (tamanho: number) => void
    codigoFilialOrcamento: string
    aviso?: string // 455487
    colunas: IColuna[],
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void
    tamanhoFonte: number
    exibirIconesAumentarDiminuirFonte?: boolean
    larguraLinha?: number
    nomeGrid?: "ITENS_ORCAMENTO" | "CONSULTAR_ITENS_ORCAMENTO"
    rotuloColunaCodigoReferencia?: "CODIGO" | "REFERENCIA"
    parametro_CHAVE_MOVIMENTACAO_ORCAMENTO: "C" | "R"
    permiteEngrenagemGrid?: boolean // 418506
}

export const AcoesHead = memo((props: AcoesHeadProps) => {

    const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false)
    const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false)
    const [icon, setIcon] = useState<string>('arrow_drop_up')
    const compararColunasFn = useMemo(
        () => R.includes(props.nomeGrid, ["ITENS_ORCAMENTO", null, undefined]) ? compararColunasGridItens : compararColunasGridConsultaItens,
        [props.nomeGrid]
    )

    const selecaoDeColunas = <SelecionarColunasParaExibicao
        colunas={(props.colunas ?? []).map(coluna => ({
            nome: coluna.Nome,
            selecionada: coluna.Selecionada,
            colunaOriginal: coluna
        }) as ColunaSelecao)}
        mostrar={exibirSelecaoColunas}
        onClose={() => setExibirSelecaoDeColunas(false)}
        funcaoOrdenacao={(c1, c2) => {
            return compararColunasFn(
                c1.colunaOriginal as IColuna,
                c2.colunaOriginal as IColuna,
                props.codigoFilialOrcamento,
                props.parametro_CHAVE_MOVIMENTACAO_ORCAMENTO
            )
        }}
        funcaoTraducaoNome={coluna => {
            return traduzirNomeColuna({
                nomeColuna: coluna.nome,
                nomeGrid: props.nomeGrid,
                codigoOuReferencia: R.includes(props.rotuloColunaCodigoReferencia, ["CODIGO", null, undefined]) ? "CODIGO" : "REFERENCIA"
            })
        }}
        onToggleColunaSelecionada={(coluna, selecionada) => props.onToggleColunaSelecionada(coluna.nome, selecionada)}
        onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
    />



    const selecaoDeColunasDialog = <Dialog open={exibirSelecaoColunas} onClose={() => setExibirSelecaoDeColunas(false)} PaperComponent={PaperArrastavel}>
        <DialogTitle>
            Selecionar colunas para exibição
        </DialogTitle>
        <DialogContent>
            {selecaoDeColunas}
        </DialogContent>
    </Dialog>

    const botoes = <section
        id={`AcoesHead_Botoes_secao_${props.id}`}
        key={`AcoesHead_Botoes_secao_${props.id}`}
        className="_flex _flex-row _gap-x-2"
    >

        {(props.permiteEngrenagemGrid ?? false) && <>
            <FontAwesomeIcon icon={faGear} className="_text-2xl _cursor-pointer" onClick={() => setExibirSelecaoDeColunas(true)}
                id={`AcoesHead_Botoes_icon_${props.id}`}
                key={`AcoesHead_Botoes_icon_${props.id}`}
            />
        </>}

        {(props.exibirIconesAumentarDiminuirFonte ?? true) && <>
            <button
                id={`AcoesHead_BotaoAumentarFonte_${props.id}`}
                key={`AcoesHead_BotaoAumentarFonte_${props.id}`}
                className={clsx('no-global-button', estilosGridItens.botaoAumentarDiminuirFonte)}
                onClick={() => props.onAlterarFonte?.(props.tamanhoFonte + 1)}
                disabled={props.tamanhoFonte >= 26}
            >A+
            </button>
            <button
                id={`AcoesHead_BotaoDiminuirFonte_${props.id}`}
                key={`AcoesHead_BotaoDiminuirFonte_${props.id}`}
                className={clsx('no-global-button', estilosGridItens.botaoAumentarDiminuirFonte)}
                onClick={() => props.onAlterarFonte?.(props.tamanhoFonte - 1)}
                disabled={props.tamanhoFonte <= 8}
            >A-
            </button>
        </>
        }
    </section>

    const dicas = <div className="_flex _flex-row _gap-x-8 _text-sm"
        id={`AcoesHead_BotaoAumentarFonte_Div2_${props.id}`}
        key={`AcoesHead_BotaoAumentarFonte_Div2_${props.id}`}
    >
        {props.aviso?.length > 0 &&  // 455487
            <span
                className={tipografia.dicaUsuario}
                style={{ color: 'red' }}
                title={props.aviso}
                id={`AcoesHead_BotaoAumentarFonte_AvisoNaoRecalculado_${props.id}`}
                key={`AcoesHead_BotaoAumentarFonte_AvisoNaoRecalculado_${props.id}`}
            >{props.aviso}
            </span>
        }
        <span className={tipografia.dicaUsuario}
            style={{ overflow: "hidden" }}
            id={`AcoesHead_BotaoAumentarFonte_DicaRolagemHorizontal_${props.id}`}
            key={`AcoesHead_BotaoAumentarFonte_DicaRolagemHorizontal_${props.id}`}
            title='Mantenha a tecla SHIFT pressionada para rolar na horizontal'>
            Mantenha a tecla <kbd>SHIFT</kbd> pressionada para rolar na horizontal
        </span>

        <span className={tipografia.dicaUsuario}
            style={{ overflow: "hidden" }}
            id={`AcoesHead_BotaoAumentarFonte_DicaRolagemVertical_${props.id}`}
            key={`AcoesHead_BotaoAumentarFonte_DicaRolagemVertical_${props.id}`}
            title='Segure CTRL e use as setas de direção para movimentar pelos campos edtiáveis do grid'>
            Segure <kbd>CTRL</kbd> e use as setas de direção para movimentar pelos campos edtiáveis do grid
        </span>
    </div>

    return <>
        <table style={{
            width: props.larguraLinha != undefined ? `${props.larguraLinha}px` : "100%"
            , maxWidth: "100%"
        }} className="_mt-4"
            id={`AcoesHead_Botoes_div_${props.id}`}
            key={`AcoesHead_Botoes_div_${props.id}`}
        >
            <tbody>
                <tr
                    id="AcoesHead_table-headgrid-itensarrow_tr"
                >
                    <td style={{ maxHeight: "40px" }} className={clsx(["_flex _flex-row _gap-x-2 _items-center", estilosTableHead.acoesHead])}>
                        <button
                            style={{ marginLeft: '14px', height: '20px' }}
                            id={`AcoesHead_table-headgrid-itensarrow_${props.id}`}
                            key={`AcoesHead_table-headgrid-itensarrow_${props.id}`}
                            className="no-global-button"
                            title={mostrarFerramentas ? "Ocultar ferramentas" : "Exibir ferramentas"}
                            onClick={() => {
                                setMostrarFerramentas(!mostrarFerramentas);
                                setIcon(icon == "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up");
                            }}
                        >
                            <Icon id={`AcoesHead_table-headgrid-itensarrowIcone_${props.id}`}>{icon}</Icon>
                        </button>

                        {mostrarFerramentas && botoes}

                        {dicas}
                    </td>
                </tr>
            </tbody>
        </table>

        {exibirSelecaoColunas && selecaoDeColunasDialog}
    </>
})